import { useIframeMessaging } from "../iframeMessaging/useIframeMessaging";

export const useIframeHeightAdjust = (iframeName: string) => {
  const { publishMessage } = useIframeMessaging();

  return (height: string) => {
    publishMessage('iframeAdjustHeight', { iframeName, height });
  }
}
